// extracted by mini-css-extract-plugin
export default {"container":"LiveLesson_container__t0kIF","endedTextLight":"LiveLesson_endedTextLight__fuk3Q","endedTextBlack":"LiveLesson_endedTextBlack__JGpJF"};